import { IconButton, makeStyles, Menu, MenuItem } from "@material-ui/core";
import { Check, Clear } from "@material-ui/icons";
import Typography from "../Typography/Typography";
import Question from "./svgs/Question";
import { MouseEvent, FC } from "react";

const statuses = ["Undecided", "Accepted", "Declined"];
const icons = [<Question fontSize="small" />, <Check fontSize="small" />, <Clear fontSize="small" />];
type Status = typeof statuses[number];

interface AcceptanceStatusListProps {
	handleCloseOnClick: (e: MouseEvent<HTMLLIElement, MouseEvent>, status: Status) => void;
	anchorEl: HTMLElement | null;
	onClick: (e: MouseEvent<HTMLLIElement, MouseEvent>) => void;
	disabled: boolean | undefined;
}

const AcceptanceStatusList: FC<AcceptanceStatusListProps> = ({ onClick, anchorEl, handleCloseOnClick, disabled }) => {
	const { borderIcon, list } = useStyles();

	return (
		<Menu
			id="simple-menu"
			anchorEl={anchorEl}
			disableScrollLock
			PaperProps={{
				style: {
					borderRadius: "0.125rem",
					boxShadow: "0 0.375rem 0.625rem 0 rgba(0, 0, 0, 0.08)",
					border: "0",
					marginBottom: "10px",
				},
			}}
			transformOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			marginThreshold={10}
			open={Boolean(anchorEl)}
			onClose={onClick}
		>
			{statuses.map((s, i) => (
				<MenuItem className={list} disabled={disabled} button key={i} onClick={(e) => handleCloseOnClick(e as any, s)}>
					<IconButton size="small" classes={{ root: borderIcon }}>
						{icons[i]}
					</IconButton>
					&nbsp; &nbsp; &nbsp;
					<Typography>{s}</Typography>
				</MenuItem>
			))}
		</Menu>
	);
};

const useStyles = makeStyles({
	borderIcon: {
		border: `1px solid #ffffff`,
		backgroundColor: "#ffffff",
		color: "#367bf5",
		boxShadow: "0 0 1.413rem 0 rgba(0, 0, 0, 0.08)",
	},
	list: {
		display: "flex",
		alignItems: "center",
		justifyContent: "start",
		width: "100%",
	},
});

export default AcceptanceStatusList;
